import { useSyncExternalStore } from "react";

/**
 * MUI's `useMediaQuery`, as the donor screens call it: false on the server and
 * on the first client render (hydration), then the live answer, following the
 * query as it changes.
 *
 * Hoisted out of `mui-table-pagination.tsx` when the spec lines body needed the
 * same hook for its `theme.breakpoints.up('md')` (#695) — one copy of the
 * subscription rather than two.
 */
export function useMatchesMedia(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** The donor theme's `breakpoints.up('md')` — 900px (`theme.ts:191-199`). */
export const MUI_UP_MD_QUERY = "(min-width: 900px)";

/** The donor theme's `breakpoints.up('lg')` — 1200px (`theme.ts:191-199`). */
export const MUI_UP_LG_QUERY = "(min-width: 1200px)";
